module.exports = __webpack_public_path__ + "img/full5-min.5bc69a18.png";